import React, { useEffect, useState } from "react";
import { m as motion } from "../../shared/components/Motion";
import "./scrollup.css";

const ScrollUp = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      setShowScroll(scrollTop > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 20 },
    },
  };

  return (
    <motion.a
      title="scrollup"
      href="#home"
      className={`scrollup ${showScroll ? "show-scroll" : ""}`}
      onClick={scrollToTop}
      initial="hidden"
      animate={showScroll ? "visible" : "hidden"}
      variants={scrollUpVariants}
    >
      <i className="uil uil-arrow-up scrollup__icon"></i>
    </motion.a>
  );
};

export default ScrollUp;
